export function parsePermission(permission: number): number {
  return Math.pow(2, permission)
}
